import padZero from './padZero';

export default function formatISODate(isoDate: string): string {
  const date = new Date(isoDate.replace(/Z$/, ''));
  const month = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();
  return `${padZero(month + 1)}/${padZero(day)}/${year}`;
}
